import type { ElementType } from 'react';

import type { ISubAction } from 'pages/Batch/utils/analytics';
import { SubToolNames } from 'pages/Batch/utils/analytics';

import { IconPositionCenter } from '@picsart/design-system/foundation/icons/IconPositionCenter';
import { IconPositionTopLeft } from '@picsart/design-system/foundation/icons/IconPositionTopLeft';
import { IconPositionTopCenter } from '@picsart/design-system/foundation/icons/IconPositionTopCenter';
import { IconPositionTopRight } from '@picsart/design-system/foundation/icons/IconPositionTopRight';
import { IconPositionDownLeft } from '@picsart/design-system/foundation/icons/IconPositionDownLeft';
import { IconPositionDownCenter } from '@picsart/design-system/foundation/icons/IconPositionDownCenter';
import { IconPositionDownRight } from '@picsart/design-system/foundation/icons/IconPositionDownRight';

export const BG_SUBTOOL_IDS = {
  CAMERA_ROLL: 'camera_roll',
  COLOR: 'color',
  BACKGROUND: 'background',
  POSITION: 'position',
  AI_BACKGROUND: 'ai_background',
  RATIO: 'ratio',
} as const;

export enum ObjectPosition {
  CENTER = 'center',
  TOP_LEFT = 'topLeft',
  TOP = 'top',
  TOP_RIGHT = 'topRight',
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM = 'bottom',
  BOTTOM_RIGHT = 'bottomRight',
}

export const POSITION_ITEMS: { id: ObjectPosition; label: string; icon: ElementType }[] = [
  { id: ObjectPosition.CENTER, label: 'Center', icon: IconPositionCenter },
  { id: ObjectPosition.BOTTOM, label: 'Bottom', icon: IconPositionDownCenter },
  { id: ObjectPosition.BOTTOM_LEFT, label: 'Bottom L', icon: IconPositionDownLeft },
  { id: ObjectPosition.BOTTOM_RIGHT, label: 'Bottom R', icon: IconPositionDownRight },
  { id: ObjectPosition.TOP, label: 'Top', icon: IconPositionTopCenter },
  { id: ObjectPosition.TOP_LEFT, label: 'Top L', icon: IconPositionTopLeft },
  { id: ObjectPosition.TOP_RIGHT, label: 'Top R', icon: IconPositionTopRight },
];

const POSITION_LABEL_BY_ID = new Map(POSITION_ITEMS.map(p => [p.id, p.label]));

const BG_SUBTOOL_DROP_NAMES = new Set<string>([SubToolNames.myBg, SubToolNames.color, SubToolNames.centerObject, 'ratio', 'my_bg', 'color']);

export function buildBackgroundSubTools(subTools: ISubAction[], objectPosition: ObjectPosition | null): ISubAction[] {
  const result = subTools.filter(entry => entry.name !== SubToolNames.position && entry.name !== 'position' && !BG_SUBTOOL_DROP_NAMES.has(entry.name));

  if (objectPosition) {
    result.push({ name: 'position', value: POSITION_LABEL_BY_ID.get(objectPosition) ?? objectPosition });
  }

  return result;
}
